import React from 'react';
import { Helmet } from 'react-helmet-async';
import './NoPage.css';

const NoPage = () => {
    return (
        <>
            <Helmet>
                <title>Page not found | Cell Cash</title>
                <meta
                    name="description"
                    content="Page not found page description"
                    data-rh="true"
                />
            </Helmet>

            <section className="Search-section section-padding" id="section_1">
                <div className="container bgsellSearch col-lg-6 col-md-6">
                    <div style={{ padding: " 50px 10px 50px 10px" }}>
                        <div className=''>
                            <div className="row " >

                                <div className="col-lg-12 col-md-12 col-12 mb-4 mb-lg-0">
                                    <div className='mb-4 text-center'>
                                        <h1 className="mt-4 mb-0 mb-4">Oops, page not found...</h1>

                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>

                </div>
            </section>


        </>

    )
}

export default NoPage;
